import { Injectable } from "@angular/core";
import { NewsDetailViewModel, NewsDataModel } from "../../shared/models/news.model";
import { ContentType, ImageOrientation, DateFormatTyps } from "../../shared/contentTypes";
import { RatingService } from "../../services/rating.service";
import { LikeService } from "../../services/like.service";
import { CoreLogService } from "../../services/log.service";
import { Observable } from "rxjs";
import DateManager from "../../shared/dateManager";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { UserHelperService } from "../../services/userHelper.service";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";

@Injectable()
export class NewsDetailService {
  private _newsObsServ: IObjectObserver<NewsDataModel>;
  constructor(private _coreLogService: CoreLogService,
    private _ratingService: RatingService,
    private _likeService: LikeService,
    private _userHelperService: UserHelperService,
    private objObsInjectHelper: CircularInjectionHelper) {
    this._newsObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<NewsDataModel>(ContentType.News, objObsInjectHelper);
  }

  public get ObserveChanges(): Observable<(string | number)[]> {
    return this._newsObsServ.ObserveChanges;
  }

  /**
    * Getting the newsDataModel by Id
    * Create eventViewModelList
    * @id id of Event
    * @result return a promise that resolves a  eventViewModel
    */
   public GetNewsViewModel(id: number | string): Promise<NewsDetailViewModel> {
    const me = this;
    return new Promise<NewsDetailViewModel>((resolve, reject) => {
      // gets undeleted events
      me._newsObsServ.GetObject(id)
        .then((newsDetail) => {
          me.mapDataModelToViewModel(newsDetail).then(resolve)
            .catch((e) => {
              me._coreLogService.error("NewsDetailService._newsObsServ.GetObject", "mapDataModelToViewModel", e);
              reject();
            });
        })
        .catch((e) => {
          me._coreLogService.error("NewsDetailService._newsObsServ.GetObject", "_newsObsServ.GetObject", e);
          reject();
        });
    });
  }

  // Mapper

  /**
  * map a EventDataModel to EventViewModel
  * @param model Get a EventDataModel for mapping
  * @result return a EventViewModel
  */
   private async mapDataModelToViewModel(model: NewsDataModel): Promise<NewsDetailViewModel> {
    const me = this;
    if (model) {
      const viewModel = new NewsDetailViewModel();
      viewModel.id = model.id;
      viewModel.dateYMD = model.date_ymd;
      viewModel.date = DateManager.MomentAsString(model.date, DateFormatTyps.DDMMYYYY);
      viewModel.day = viewModel.date.slice(0, 3);
      viewModel.month = viewModel.date.slice(3, 6);
      viewModel.year = viewModel.date.slice(6);
      viewModel.momentDate = model.date;
      viewModel.label_de = model.label_de;
      viewModel.label_en = model.label_en;
      viewModel.text_de = model.text_de.replace("\n","<br>");
      viewModel.text_en = model.text_en.replace("\n","<br>");;
      viewModel.image_photo = ContentType.News + "/" + model.id + "_photo_" + ImageOrientation.Landscape + "/" + model.last_image_update_at_ymd + "/" + model.last_image_update_at_hms;

      try {
        viewModel.rate = await me._ratingService.GetRatingStars(ContentType.News, model.id);
      } catch (error) {
        me._coreLogService.error("NewsService.mapDataModelToViewModel", "GetRatingStars try catch", error);
      }
  
      try {
        viewModel.like = await me._likeService.HasLike(ContentType.News, model.id);
      } catch (error) {
        me._coreLogService.error("NewsService.mapDataModelToViewModel", "HasLike try catch", error);
      }
      return Promise.resolve(viewModel);

    } else {
      return Promise.resolve(null);
    }
  }
}
